import axios from 'axios'
import { SALE_API_URL } from 'lib/env'
import { createError } from 'requests/errors'

export const getSaleList = async (filter) => {
  try {
    const res = await axios.post(SALE_API_URL + '/sales/list', filter)
    return res.data
  } catch (e) {
    return createError(e)
  }
}